import { CheckDTOStatusEnum } from '@reposit/api-client';
import moment from 'moment';
import React from 'react';
import { useDispatch } from 'react-redux';
import { FLASH_MESSAGE_TIMEOUT, useFlashMessage } from '../../containers/FlashMessage';
import { CheckEntity } from '../../redux/entities/entities.types';
import { OVERRIDE_REFERENCE_CHECK_STORE_KEY, overrideReferenceCheckRequested } from '../../redux/referencing/referencing.actions';
import Button from '../Button';
import FlashMessage from '../FlashMessage';
import IdentifierValue from '../IdentifierValue';
import RepositCard from '../Reposit/RepositCard';
import { Table, Tbody, Td, Thead, Tr } from '../Table';

interface ChecksProps {
  checks: CheckEntity[];
}

const Checks: React.FC<ChecksProps> = ({ checks }) => {
  const dispatch = useDispatch();
  const [flashMessagePayload, dismissFlashMessage] = useFlashMessage([OVERRIDE_REFERENCE_CHECK_STORE_KEY]);

  return (
    <RepositCard
      flush
      title="Checks"
      flashMessage={
        flashMessagePayload ? (
          <FlashMessage onDismiss={dismissFlashMessage} timeRemaining={FLASH_MESSAGE_TIMEOUT} payload={flashMessagePayload} />
        ) : undefined
      }
    >
      <Table>
        <Thead>
          <Tr>
            <Td>ID</Td>
            <Td>Provider</Td>
            <Td>Type</Td>
            <Td>Status</Td>
            <Td>CreatedAt</Td>
            <Td>Action</Td>
          </Tr>
        </Thead>
        <Tbody>
          {checks.map((check) => (
            <Tr key={check.id}>
              <Td>
                <IdentifierValue>{check.id}</IdentifierValue>
              </Td>
              <Td>{check.provider}</Td>
              <Td>{check.type}</Td>
              <Td>{check.status}</Td>
              <Td>{moment(check.createdAt).format('DD/MM/YYYY HH:mm')}</Td>
              <Td>
                {check.status === CheckDTOStatusEnum.INREVIEW ? (
                  <Button onClick={() => dispatch(overrideReferenceCheckRequested(check.id))}>Pass Reference</Button>
                ) : (
                  check.status
                )}
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </RepositCard>
  );
};

export default Checks;
